import {
  Card,
  Col,
  Image,
  Row,
  Space,
  Typography,
  Divider,
  Badge,
  Spin,
  Tooltip,
  Modal,
  Button,
  Popover,
  Table,
} from "../../common/utils/antd-imports/AntdImports";
import React, { useRef, useEffect } from "react";
import Metrics from "../../../assests/metrics-icon.svg";
import Product from "../../../assests/products-14X48.svg";
import Billboard from "../../../assests/Billboard-icon.svg";
import Navigation from "../../../assests/Navigation.svg";
import ChatBotSparkles from "../../../assests/chatbot-sparklesIcon.svg";
import "./ProductCard.css";
import ProductModalPopUp from "../../modal/product-detail-modal/ProductModalPopUp";
import "../../modal/product-detail-modal/ProductModalPopUp.css";
import { useState } from "react";
import { API_BASE_URL_IMAGE } from "../../../services/common";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPricePredictionOfProducts } from "../../../store/thunks/common-thunks/commonThunk";
import NotifyModel from "../../modal/notify-model/NotifyModel";
import { useMediaQuery } from "react-responsive";
import { formatToUSCurrency, handleCopy } from "../utils/Utils";
import LoginAlert from "../../modal/login-alert/LoginAlert";
import "../../../main.css";
import EmptyViewCard from "../../common/empty-view-card/EmptyViewCard";
import { ReactComponent as NotifyIcon } from "../../../assests/notify-icon.svg";
import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import { InfoCircleOutlined } from "@ant-design/icons";
import dummyImage from "../../../assests/images/no-image.png";
import RecommendedProductType from "../../modal/recommended-products/RecommendedProductType";
import { ReactComponent as AddIcon } from "../../../assests/add-product-icon.svg";
import { setIsProductPopUp } from "../../../store/slices/common-slice/product-details-action-items/productDetailsActionItemslice";
import { addBreadcrumb } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import AdPlacement from "../../../features/Ads/adPlacement/adPlacement";
import dayjs from "dayjs";
const { Text } = Typography;

const formatDate = (timestamp) => {
  if (!timestamp) return ""; // or return "-"
  const date = new Date(parseInt(timestamp, 10));
  if (isNaN(date.getTime())) {
    return "";
  }
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
};
const getDateValues = (dateField) => {
  if (Array.isArray(dateField)) {
    return dateField;
  }
  return dateField ? [dateField] : [];
};
const formatSize = (value) => {
  if (!value) return "";
  return value
    .replace(" feet", "'") // Convert feet to '
    .replace(/\s*line\s*inches/i, '"') // Convert inches to "
    .replace(" pixels", " px"); // Convert pixels to px
};

export const MobileProductCard = ({
  currentPageData,
  recommendedProducts,
  selectedProductId,
  onScrollEnd,
  isMapView,
  isLoading,
}) => {
  const productRefs = useRef({}); // Store refs for each product card
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isTab = useMediaQuery({ maxWidth: 1024 });

  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  // For the opening the view-button-page for the price-details
  const [isCampaignsPage, setIsCampaignsPage] = useState(false);
  const previousPathFromStore = useSelector(
    (state) => state.route.previousPath,
  );
  const { isProductPopUp } = useSelector((state) => state.productDetailsSlice);
  const stablePreviousPath = useRef(previousPathFromStore);
  const [notify, setNotify] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [updatedPageData, setUpdatedPageData] = useState(
    currentPageData?.length ? currentPageData : [],
  );
  const containerRef = useRef(null);

  const [selectedProdId, setSelectedProdId] = useState(null);
  const [showAIPrice, setShowAIPrice] = useState(false);
  const [loginPopoverVisible, setLoginPopoverVisible] = useState(false);

  // const ToProductDetails = (product) => {
  //   navigate("/buyer/viewproduct", {
  //     state: { product, isCampaignsPage: isCampaignsPage },
  //   });
  // };
  const { predictionLoader, prices } = useSelector((state) => state.products);
  // const handleProductDetails = (product) => {
  //   dispatch(setIsProductPopUp(!isProductPopUp));
  //   setSelectedProduct(product);
  // };
  const handleProductDetails = (product) => {
    if (isLoggedIn) {
      navigate(`/buyer/productsdetails?_id=${btoa(product?.id)}`, {
        state: {
          productId: product?.id,
          isCampaignsPage: isCampaignsPage,
        },
      });
      dispatch(
        addBreadcrumb({
          title: product?.title,
          path: `/buyer/productsdetails?_id=${btoa(product?.id)}`,
        }),
      );
      // setIsProductPopUp((prevState) => !prevState);
      setSelectedProduct(product);
    } else {
      navigate(`/productsdetails?_id=${btoa(product?.id)}`, {
        state: {
          productId: product?.id,
          isCampaignsPage: isCampaignsPage,
        },
      });
      dispatch(
        addBreadcrumb({
          title: product?.title,
          path: `/productsdetails?_id=${btoa(product?.id)}`,
        }),
      );
    }
    // setIsProductPopUp((prevState) => !prevState);
    setSelectedProduct(product);
  };
  const showMobileAIPrice = (productId) => {
    if (!isLoggedIn) {
      setLoginPopoverVisible(true);
    } else {
      setShowAIPrice(true);
      setSelectedProdId(productId);
      dispatch(getPricePredictionOfProducts({ product_id: productId }));
    }
  };
  const estimatedPriceTooltip = () => {
    return "This is an estimated market price generated by AI to guide you. The actual seller's price may differ.";
  };
  const getPredictedPrice = (priceValue) => {
    if (!priceValue) return "";
    let modifiedNumber = priceValue.split("$");
    return Number(modifiedNumber[1]).toFixed(2);
  };

  useEffect(() => {
    stablePreviousPath.current = previousPathFromStore;
  }, [previousPathFromStore]);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        onScrollEnd();
      }
    };

    const node = containerRef.current;
    if (node) node.addEventListener("scroll", handleScroll);

    return () => {
      if (node) node.removeEventListener("scroll", handleScroll);
    };
  }, [onScrollEnd]);

  // Scroll to the selected product when it changes
  useEffect(() => {
    if (selectedProductId && productRefs.current[selectedProductId]) {
      setTimeout(() => {
        productRefs.current[selectedProductId]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 300);
    }
  }, [selectedProductId]);
  useEffect(() => {
    if (recommendedProducts?.length > 0) {
      setUpdatedPageData(
        recommendedProducts?.map((product) => {
          if (product?.rateCard === "0") {
            return {
              ...product,
              rateCard: "Estimated Market Value",
            };
          }
          return product;
        }),
      );
    } else {
      if (currentPageData?.length > 0) {
        setUpdatedPageData(
          currentPageData?.map((product) => {
            if (Number(product?.product_details?.[0]?.rateCard) === 0) {
              return {
                ...product?.product_details?.[0],
                rateCard: "Estimated Market Value",
              };
            }
            return product?.product_details?.[0];
          }),
        );
      } else {
        setUpdatedPageData([]);
      }
    }
  }, [currentPageData]);

  useEffect(() => {
    if (
      stablePreviousPath?.current?.includes("/mycampaigns") ||
      stablePreviousPath?.current?.includes("campaigndetails")
    ) {
      setIsCampaignsPage(true);
    } else {
      setIsCampaignsPage(false);
    }
  }, [stablePreviousPath, previousPathFromStore]);
  const tableColumns = [
    {
      title: "Term",
      dataIndex: "term",
      key: "term",
      width: "auto",
    },
  ];
  const getTableColumns = (product) => [
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
    ...(product?.type === "Digital"
      ? [
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
          },
        ]
      : []),
  ];
  const getTableData = (product) => {
    if (!product) return [];

    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    const quantities = product?.unitQty || [];

    return fromDates.map((from, index) => ({
      key: index,
      startDate: dayjs(Number(from?.$date?.$numberLong)).format("MMM DD, YYYY"),
      endDate: dayjs(Number(toDates?.[index]?.$date?.$numberLong)).format(
        "MMM DD, YYYY",
      ),
      quantity: product?.type === "Digital" ? (quantities[index] ?? "-") : "-",
    }));
  };
  const safeIncludes = (value, searchValue) => {
    if (Array.isArray(value)) {
      return value?.some((item) => String(item ?? "")?.includes(searchValue));
    }
    return String(value ?? "")?.includes(searchValue);
  };
  const productView = (product, rateCard) => {
    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    const minFromTimestamp =
      fromDates.length > 0
        ? Math.min(...fromDates.map((item) => Number(item?.$date?.$numberLong)))
        : null;
    const maxToTimestamp =
      toDates.length > 0
        ? Math.max(...toDates.map((item) => Number(item?.$date?.$numberLong)))
        : null;
    const firstFromDate = minFromTimestamp
      ? formatDate(minFromTimestamp)
      : "N/A";
    const firstToDate = maxToTimestamp ? formatDate(maxToTimestamp) : "N/A";
    const slotsLength = Math.max(fromDates?.length, toDates?.length);
    const popoverContent = (
      <>
        <div className="slots-popover">
          <div className="product-title" style={{ marginBottom: "10px" }}>
            Available Slots
          </div>
          <Table
            columns={getTableColumns(product)}
            dataSource={getTableData(product)}
            pagination={false}
            rowKey="key"
            size="small"
            className="billboard-table"
          />
        </div>
        {/* <Table
          className="billboard-table"
          columns={tableColumns}
          pagination={false}
          rowKey="key"
        /> */}
      </>
    );
    return (
      <Col
        span={24}
        // key={index}
        ref={(el) => (productRefs.current[product?.id] = el)}
        // onClick={() => ToProductDetails(product)}
      >
        {new Date(Number(product?.to_date?.$date?.$numberLong)) <=
          new Date() && (
          <div
            style={{
              position: "absolute",
              right: 8,
              zIndex: 1,
              backgroundColor: "#FFD9E1",
              color: "#d2042d",
              fontWeight: "400",
              fontSize: "13px",
              padding: "8px",
              borderBottomLeftRadius: "10px",
              userSelect: "none",
              pointerEvents: "none",
              whiteSpace: "nowrap",
            }}
          >
            Not Available
          </div>
        )}
        <Card
          className={`product-card product-item ${
            selectedProductId === product?.id ? "highlight" : ""
          }`}
          hoverable
        >
          <div>
            <div>
              <div
                onClick={
                  // isTab
                  // ? () => ToProductDetails(product)
                  // :
                  () => handleProductDetails(product)
                }
              >
                <Row>
                  <Col md={8} xs={9} xl={8}>
                    {product?.insert_type &&
                    product?.insert_type !== "Bulk_state" ? (
                      <>
                        <Image
                          className="product-image"
                          src={
                            product?.insert_type == "Bulk_state_Test"
                              ? `${API_BASE_URL_IMAGE}` + product?.image?.[0]
                              : product?.image[0]
                          }
                          preview={false}
                          alt=""
                          style={{ maxWidth: "100%" }}
                        />
                      </>
                    ) : product?.image && product?.image?.[0] ? (
                      <>
                        <Image
                          className="product-image"
                          src={`${API_BASE_URL_IMAGE}` + product?.image?.[0]}
                          preview={false}
                          alt=""
                          style={{ maxWidth: "100%" }}
                        />
                      </>
                    ) : (
                      <>
                        <Image
                          className="product-image"
                          src={dummyImage}
                          preview={false}
                          alt=""
                          style={{ maxWidth: "100%" }}
                        />
                      </>
                    )}
                  </Col>

                  <Col md={14} xs={15} style={{ paddingLeft: 5 }}>
                    <div style={{ display: "flex" }}>
                      <Text className="product-id">
                        {product?.siteNo}{" "}
                        {new Date(
                          Number(product?.to_date?.$date?.$numberLong),
                        ) <= new Date()}
                      </Text>
                    </div>
                    <div>
                      <Tooltip
                        styles={{
                          body: { color: "#fff" },
                        }}
                        title={
                          <pre className="tooltip-product-card">
                            {product?.title}
                          </pre>
                        }
                      >
                        <Text
                          className="product-title-mobile-view truncate"
                          strong
                        >
                          {product?.title}
                        </Text>
                      </Tooltip>
                    </div>
                    <div>
                      <Text style={{ fontFamily: "Roboto" }}>
                        City : {product?.city_name}
                      </Text>
                    </div>
                    <div className="available-container">
                      <Text className="available-txt">Available from</Text>
                    </div>
                    <p className="product-availability  product-availability-desk">
                      {firstFromDate}
                      <div className="format-arrow">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="16"
                          viewBox="0 0 23 16"
                          fill="none"
                        >
                          <path
                            d="M22.7071 8.7071C23.0976 8.31658 23.0976 7.68342 22.7071 7.29289L16.3431 0.928931C15.9526 0.538406 15.3195 0.538406 14.9289 0.928931C14.5384 1.31946 14.5384 1.95262 14.9289 2.34314L20.5858 8L14.9289 13.6569C14.5384 14.0474 14.5384 14.6805 14.9289 15.0711C15.3195 15.4616 15.9526 15.4616 16.3431 15.0711L22.7071 8.7071ZM8.74228e-08 9L22 9L22 7L-8.74228e-08 7L8.74228e-08 9Z"
                            fill="#D2042D"
                          />
                        </svg>
                      </div>
                      {firstToDate}
                    </p>
                    {slotsLength > 1 && (
                      <Popover
                        placement="right"
                        trigger="click"
                        content={popoverContent}
                      >
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          className="view-slots-link"
                        >
                          View Slots
                        </span>
                      </Popover>
                    )}
                  </Col>
                </Row>

                <Row className="middle-specification">
                  <Col xs={8}>
                    <Row justify="center">
                      <Image
                        className="product-size-img"
                        preview={false}
                        src={Product}
                        alt="size"
                        style={{ maxWidth: "100%" }}
                      />
                    </Row>
                    <Row justify="center">
                      <span className="product-size-text">
                        {product?.type?.toLowerCase() == "media" ? (
                          <> {product?.length}</>
                        ) : (
                          <>
                            {formatSize(product?.width)} X{" "}
                            {formatSize(product?.height)}
                          </>
                        )}
                      </span>
                    </Row>
                  </Col>

                  <Col xs={8}>
                    <Row justify="center">
                      <Image
                        className="products-metric-icon"
                        preview={false}
                        src={Metrics}
                        alt="metrics"
                        style={{ maxWidth: "100%" }}
                      />
                    </Row>
                    <Row justify="center">
                      <span className="product-reach">
                        {Number(product?.secondImpression).toLocaleString()}{" "}
                        <span>+ per week</span>
                      </span>
                    </Row>
                  </Col>

                  <Col xs={8}>
                    <Row justify="center">
                      <Image
                        className="product-bill-image"
                        src={Billboard}
                        preview={false}
                        alt="Products"
                        style={{ maxWidth: "100%" }}
                      />
                    </Row>
                    <Row justify="center">
                      <span className="product-type">{product?.type}</span>
                    </Row>
                  </Col>
                </Row>
              </div>
              <Row xs={24} md={8} className="product-last-section-detail-miles">
                <Col span={12}>
                  <div className="price-section">
                    <Image
                      className="navigation-icon"
                      preview={false}
                      width={15}
                      src={Navigation}
                      alt=""
                    />
                    <Text className="miles-text">0.5miles away</Text>{" "}
                  </div>
                </Col>
                <Col span={12}>
                  <div className="procduct-price-detail-section">
                    <div>
                      {!safeIncludes(
                        product?.rateCard,
                        "Estimated Market Value",
                      ) ? (
                        <>
                          <Text strong className="price-text">
                            {formatToUSCurrency(Number(product?.rateCard))}
                          </Text>
                          <span className="per-week"> Per 4 Weeks</span>
                        </>
                      ) : (
                        <>
                          {showAIPrice && product?.id === selectedProdId ? (
                            <>
                              {predictionLoader ? (
                                <div className="loading-css">
                                  <Spin size="small" />
                                </div>
                              ) : (
                                <Badge
                                  count={
                                    <span className="product-card-badge">
                                      <div>
                                        <span strong className="price-text">
                                          {formatToUSCurrency(
                                            getPredictedPrice(
                                              prices?.predicted_price
                                                ?.estimated_price,
                                            ),
                                          )}
                                        </span>
                                        <span className="per-week">
                                          {" "}
                                          Per 4 Weeks
                                        </span>
                                      </div>
                                      <div className="estimated-header">
                                        <Image
                                          className="sparkles"
                                          src={ChatBotSparkles}
                                          preview={false}
                                        />
                                        <span className="default-color">
                                          {" "}
                                          Estimated Market Value{" "}
                                        </span>
                                        <Tooltip
                                          placement="top"
                                          title={estimatedPriceTooltip()}
                                        >
                                          <InfoCircleOutlined currentColor="#000" />
                                        </Tooltip>
                                      </div>
                                      {formatToUSCurrency(
                                        getPredictedPrice(
                                          prices?.predicted_price
                                            ?.price_lower_limit,
                                        ),
                                      )}{" "}
                                      -
                                      {formatToUSCurrency(
                                        getPredictedPrice(
                                          prices?.predicted_price
                                            ?.price_upper_limit,
                                        ),
                                      )}
                                    </span>
                                  }
                                  color="#f5f5f5"
                                ></Badge>
                              )}
                            </>
                          ) : (
                            <Text
                              className="ai-price"
                              onClick={() => showMobileAIPrice(product?.id)}
                            >
                              {product?.rateCard}
                            </Text>
                          )}
                        </>
                      )}
                    </div>
                    {/* Notify me Button for mobile view  */}
                    {new Date(Number(product?.to_date?.$date?.$numberLong)) <=
                      new Date() && (
                      <div
                        className="notify-section"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isLoggedIn) {
                            setLoginPopoverVisible(true);
                            return;
                          }
                          setSelectedProduct(product);
                          setNotify(true);
                        }}
                      >
                        <NotifyIcon style={{ color: "#d2042d" }} />
                        <div key={product?.id} className="notify-me">
                          Notify me
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <Row
            xs={24}
            md={8}
            align="middle"
            className="product-last-section-detail-map"
          >
            <Col span={12}>
              <div style={{ height: 80 }}></div>
              <div className="price-section"></div>
            </Col>
            <Col span={12}>
              <div className="procduct-price-detail-section">
                <div className="procduct-price-detail-section">
                  <div>
                    {!safeIncludes(
                      product?.rateCard,
                      "Estimated Market Value",
                    ) ? (
                      <Text strong className="price-text">
                        {formatToUSCurrency(Number(product?.rateCard))}
                      </Text>
                    ) : (
                      <>
                        {showAIPrice && product?.id === selectedProdId ? (
                          <>
                            {predictionLoader ? (
                              <div className="loading-css">
                                <Spin size="small" />
                              </div>
                            ) : (
                              <Badge
                                count={
                                  <span className="product-card-badge">
                                    <div>
                                      <span strong className="price-text">
                                        {formatToUSCurrency(
                                          getPredictedPrice(
                                            prices?.predicted_price
                                              ?.estimated_price,
                                          ),
                                        )}
                                      </span>
                                      <span className="per-week">
                                        {" "}
                                        Per 4 Weeks
                                      </span>
                                    </div>
                                    <div>
                                      <Image
                                        className="sparkles"
                                        src={ChatBotSparkles}
                                        preview={false}
                                      />
                                      <span className="default-color">
                                        {" "}
                                        Estimated Market Value
                                      </span>{" "}
                                      <Tooltip
                                        placement="top"
                                        title={estimatedPriceTooltip()}
                                      >
                                        <InfoCircleOutlined />
                                      </Tooltip>
                                    </div>
                                    <div className="price-range-mobile">
                                      Range:{" "}
                                      {
                                        prices?.predicted_price
                                          ?.price_lower_limit
                                      }{" "}
                                      to{" "}
                                      {
                                        prices?.predicted_price
                                          ?.price_upper_limit
                                      }
                                    </div>
                                  </span>
                                }
                                color="#f5f5f5"
                              />
                            )}
                          </>
                        ) : (
                          <Text
                            className="ai-price"
                            onClick={() => showMobileAIPrice(product?.id)}
                          >
                            {product?.rateCard}
                          </Text>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div>
                  {new Date(Number(product?.to_date?.$date?.$numberLong)) <=
                    new Date() && (
                    <div
                      className="notify-section"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isLoggedIn) {
                          setLoginPopoverVisible(true);
                          return;
                        }
                        setSelectedProduct(product);
                        setNotify(true);
                      }}
                    >
                      <NotifyIcon style={{ color: "#d2042d" }} />
                      <div key={product?.id} className="notify-me">
                        Notify me
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Card>

        <LoginAlert
          loginPopoverVisible={loginPopoverVisible}
          setLoginPopoverVisible={setLoginPopoverVisible}
        />
      </Col>
    );
  };
  return (
    <>
      <Row>
        {updatedPageData && updatedPageData.length > 0 && !isLoading ? (
          <>
            {updatedPageData?.map(
              (product, detailIndex) => (
                <React.Fragment key={product?.id}>
                  {/* Product Card - Full width */}
                  <div style={{ width: "100%" }}>
                    {productView(product, product?.rateCard)}
                  </div>

                  {/* Ad - Full width below product */}
                  {(detailIndex + 1) % 5 == 0 && !isMapView && (
                    <div
                      className="mobile-promo"
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <AdPlacement
                        type="products"
                        position="grid view (6th tile)"
                        className="grid-sixth-tile margin-styles"
                      />
                    </div>
                  )}
                  {updatedPageData.length < 5 &&
                    detailIndex == updatedPageData.length - 1 &&
                    !isMapView && (
                      <div
                        className="mobile-promo"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <AdPlacement
                          type="products"
                          position="grid view (6th tile)"
                          className="grid-sixth-tile margin-styles"
                        />
                      </div>
                    )}
                </React.Fragment>
              ),
              // productView(product, product?.rateCard)
            )}
          </>
        ) : (
          <>
            <div style={{ width: "100%" }}>
              <EmptyViewCard
                header={"Products..."}
                text={
                  "There are no products available for your selected criteria. Please update your filters to explore more options."
                }
              />
            </div>
          </>
        )}
      </Row>

      <ProductModalPopUp
        selectedTab={"recommonded"}
        key={isProductPopUp}
        contentName={"Check Product Availability"}
        productId={selectedProduct?.id}
        setSelectedProduct={setSelectedProduct}
        isCampaignsPage={isCampaignsPage}
      />
      <Modal
        open={notify}
        onCancel={() => setNotify(false)}
        closable={true}
        className="notify-modal"
        footer={false}
        centered
      >
        <NotifyModel
          openNotify={notify}
          setNotify={setNotify}
          product={selectedProduct}
        />
      </Modal>
    </>
  );
};

export const DesktopProductCard = ({
  currentPageData,
  recommendedProducts,
  savedCampaigns,
  campaignId,
  campaignName,
  flag = false,
  recommendFlag = false,
  passDataToParent,
}) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productId, setProductId] = useState("");
  const [predictedPrice, setPredictedPrice] = useState([]);
  const [updatedProducts, setUpdatedProducts] = useState(
    currentPageData?.length ? currentPageData : [],
  );
  const { isProductPopUp } = useSelector((state) => state.productDetailsSlice);
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const [isCampaignsPage, setIsCampaignsPage] = useState(false);
  const [loginPopoverVisible, setLoginPopoverVisible] = useState(false);
  const [recommendedProductTypeModal, setRecommendedProductTypeModal] =
    useState(false);
  const [recommendedProductType, setRecommendedProductType] = useState(null);
  const [notify, setNotify] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { predictionLoader, prices } = useSelector((state) => state.products);
  const previousPathFromStore = useSelector(
    (state) => state.route.previousPath,
  );
  const stablePreviousPath = useRef(previousPathFromStore);
  useEffect(() => {
    stablePreviousPath.current = previousPathFromStore;
  }, [previousPathFromStore]);

  const getPredictedPrice = (priceValue) => {
    if (!priceValue) return "";
    let modifiedNumber = priceValue.split("$");
    return Number(modifiedNumber[1]).toFixed(2);
  };

  // const handleProductDetails = (product) => {
  //   dispatch(setIsProductPopUp(!isProductPopUp));

  //   setSelectedProduct(product);
  //   if (flag) {
  //     localStorage.setItem("campaignId", campaignId);
  //     localStorage.setItem("CampaignName", campaignName);
  //   }
  // };
  const getTableColumns = (product) => [
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
    ...(product?.type === "Digital"
      ? [
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
          },
        ]
      : []),
  ];
  const tableColumns = [
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
  ];
  const getTableData = (product) => {
    if (!product) return [];

    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    const quantities = product?.unitQty || [];

    return fromDates.map((from, index) => ({
      key: index,
      startDate: dayjs(Number(from?.$date?.$numberLong)).format("MMM DD, YYYY"),
      endDate: dayjs(Number(toDates?.[index]?.$date?.$numberLong)).format(
        "MMM DD, YYYY",
      ),
      quantity: product?.type === "Digital" ? (quantities[index] ?? "-") : "-",
    }));
  };
  const handleProductDetails = (product) => {
    if (isLoggedIn) {
      navigate(`/buyer/productsdetails?_id=${btoa(product?.id)}`, {
        state: {
          productId: product?.id,
          isCampaignsPage: isCampaignsPage,
        },
      });
      dispatch(
        addBreadcrumb({
          title: product?.title,
          path: `/buyer/productsdetails?_id=${btoa(product?.id)}`,
        }),
      );
      // setIsProductPopUp((prevState) => !prevState);
      setSelectedProduct(product);
      if (flag) {
        localStorage.setItem("campaignId", campaignId);
        localStorage.setItem("CampaignName", campaignName);
      }
    } else {
      navigate(`/productsdetails?_id=${btoa(product?.id)}`, {
        state: {
          productId: product?.id,
          isCampaignsPage: isCampaignsPage,
        },
      });
      dispatch(
        addBreadcrumb({
          title: product?.title,
          path: `/productsdetails?_id=${btoa(product?.id)}`,
        }),
      );
    }
  };
  const safeIncludes = (value, searchValue) => {
    if (Array.isArray(value)) {
      return value.some((item) => String(item ?? "").includes(searchValue));
    }
    return String(value ?? "").includes(searchValue);
  };
  const showAIPrice = (productId) => {
    if (!isLoggedIn) {
      setLoginPopoverVisible(true);
    } else {
      // passDataToParent(true);
      setPredictedPrice([{ productuniqueId: productId, rateCard: 0 }]);
      setProductId(productId);
      dispatch(getPricePredictionOfProducts({ product_id: productId }));
    }
  };

  const handleRecommendedProductTypeModal = (product) => {
    setRecommendedProductTypeModal(true);
    setRecommendedProductType(product);
    if (flag) {
      localStorage.setItem("campaignId", campaignId);
      localStorage.setItem("CampaignName", campaignName);
    }
  };

  const estimatedPriceTooltip = () => {
    return "This is an estimated market price generated by AI to guide you. The actual seller's price may differ.";
  };
  useEffect(() => {
    if (recommendedProducts?.length > 0) {
      setUpdatedProducts(
        recommendedProducts?.map((product) => {
          if (product?.rateCard === "0") {
            return {
              ...product,
              rateCard: "Estimated Market Value",
            };
          }
          return product;
        }),
      );
    } else {
      if (currentPageData?.length > 0) {
        setUpdatedProducts(
          currentPageData?.map((product) => {
            if (Number(product?.product_details?.[0]?.rateCard) === 0) {
              return {
                ...product?.product_details?.[0],
                rateCard: "Estimated Market Value",
              };
            }
            return product?.product_details?.[0];
          }),
        );
      } else {
        setUpdatedProducts([]);
      }
    }
  }, [currentPageData]);
  useEffect(() => {
    if (
      stablePreviousPath?.current?.includes("/mycampaigns") ||
      stablePreviousPath?.current?.includes("campaigndetails")
    ) {
      setIsCampaignsPage(true);
    } else {
      setIsCampaignsPage(false);
    }
  }, [stablePreviousPath, previousPathFromStore]);

  const productView = (product, rateCard) => {
    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    const minFromTimestamp =
      fromDates.length > 0
        ? Math.min(...fromDates.map((item) => Number(item?.$date?.$numberLong)))
        : null;
    const maxToTimestamp =
      toDates.length > 0
        ? Math.max(...toDates.map((item) => Number(item?.$date?.$numberLong)))
        : null;
    const firstFromDate = minFromTimestamp
      ? formatDate(minFromTimestamp)
      : "N/A";
    const firstToDate = maxToTimestamp ? formatDate(maxToTimestamp) : "N/A";
    const slotsLength = Math.max(fromDates?.length, toDates?.length);
    const popoverContent = (
      <div className="slots-popover">
        <div className="slots-popover">
          <div className="product-title" style={{ marginBottom: "10px" }}>
            Available Slots
          </div>
          <Table
            columns={getTableColumns(product)}
            dataSource={getTableData(product)}
            pagination={false}
            rowKey="key"
            size="small"
            className="billboard-table"
          />
        </div>
      </div>
    );
    return (
      <Col lg={24} key={product?.id}>
        {new Date(Number(product?.to_date?.$date?.$numberLong)) <=
          new Date() && (
          <div
            style={{
              position: "absolute",
              right: 8,
              zIndex: 1,
              backgroundColor: "#ffe1e6",
              color: "#d93025",
              fontWeight: "600",
              fontSize: 12,
              padding: "8px",
              borderBottomLeftRadius: "10px",
              userSelect: "none",
              pointerEvents: "none",
              whiteSpace: "nowrap",
            }}
          >
            Not Available
          </div>
        )}
        <Card
          className="product-card-desk"
          onClick={() => handleProductDetails(product)}
        >
          <Row align="middle">
            <Col span={2}>
              <div className="product-image-div">
                {product?.insert_type &&
                product?.insert_type !== "Bulk_state" ? (
                  <>
                    <Image
                      className="product-image"
                      src={
                        product?.insert_type == "Bulk_state_Test"
                          ? `${API_BASE_URL_IMAGE}` + product?.image?.[0]
                          : product?.image[0]
                      }
                      preview={false}
                      alt=""
                    />
                  </>
                ) : product?.image && product?.image?.[0] ? (
                  <>
                    <Image
                      className="product-image"
                      src={`${API_BASE_URL_IMAGE}${product?.image?.[0]}`}
                      preview={false}
                      alt=""
                    />
                  </>
                ) : (
                  <>
                    <Image
                      className="product-image"
                      src={dummyImage}
                      preview={false}
                      alt=""
                      style={{ maxWidth: "100%" }}
                    />
                  </>
                )}
              </div>
            </Col>

            <Col span={6} style={{ paddingLeft: 20 }}>
              <div style={{ padding: 15 }}>
                <div className="product-copy-text-field">
                  <Text className="product-id">
                    {product?.siteNo}{" "}
                    {new Date(Number(product?.to_date?.$date?.$numberLong)) <=
                      new Date()}
                    <CopyOutlined
                      onClick={(e) => {
                        e.stopPropagation(); // prevent tooltip close
                        handleCopy(product?.siteNo);
                      }}
                      className="copy-icon"
                    />{" "}
                    <span style={{ color: "#d2042d" }}>
                      {product?.distance}
                    </span>
                  </Text>
                </div>
                <div>
                  <Tooltip
                    styles={{
                      body: { color: "#fff", backgroundColor: "#000" },
                    }}
                    title={
                      <pre className="tooltip-product-card">
                        {product?.title}
                      </pre>
                    }
                  >
                    <div className="product-copy-text-field">
                      <Text className="product-title truncate" strong>
                        {product?.title}
                      </Text>
                      <CopyOutlined
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCopy(product?.title);
                        }}
                        className="copy-icon"
                      />
                    </div>
                  </Tooltip>
                </div>
                <div>
                  <Text className="product-card-city">
                    City : {product?.city_name}
                  </Text>
                </div>
                <div>
                  <Text className="available-txt">Available</Text>
                </div>
                <div className="product-card-format-dates-div">
                  <Space direction="horizontal" size={1}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <span className="product-availability">
                        {firstFromDate}
                      </span>
                      <div className="format-arrow">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="16"
                          viewBox="0 0 23 16"
                          fill="none"
                        >
                          <path
                            d="M22.7071 8.7071C23.0976 8.31658 23.0976 7.68342 22.7071 7.29289L16.3431 0.928931C15.9526 0.538406 15.3195 0.538406 14.9289 0.928931C14.5384 1.31946 14.5384 1.95262 14.9289 2.34314L20.5858 8L14.9289 13.6569C14.5384 14.0474 14.5384 14.6805 14.9289 15.0711C15.3195 15.4616 15.9526 15.4616 16.3431 15.0711L22.7071 8.7071ZM8.74228e-08 9L22 9L22 7L-8.74228e-08 7L8.74228e-08 9Z"
                            fill="#D2042D"
                          />
                        </svg>
                      </div>
                      <span className="product-availability">
                        {firstToDate}
                      </span>
                    </div>
                  </Space>
                </div>
                {slotsLength > 1 && (
                  <Popover
                    placement="right"
                    trigger="click"
                    content={popoverContent}
                  >
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      className="view-slots-link"
                    >
                      View Slots
                    </span>
                  </Popover>
                )}
              </div>
            </Col>

            <Col span={3}>
              <Tooltip
                styles={{
                  body: { color: "#fff", backgroundColor: "#000" },
                }}
                title={<pre className="tooltip-product-card">Dimensions</pre>}
              >
                <Row justify="center">
                  <Image
                    className="product-size-img"
                    preview={false}
                    src={Product}
                    alt="image"
                  ></Image>
                </Row>
                <Row justify="center">
                  <span className="product-size-text">
                    {product?.type?.toLowerCase() == "media" ? (
                      <> {product?.length}</>
                    ) : (
                      <>
                        {formatSize(product?.width)} X{" "}
                        {formatSize(product?.height)}
                      </>
                    )}
                  </span>
                </Row>
              </Tooltip>
            </Col>
            <Divider type="vertical" className="product-card-divider-css" />

            <Col span={4}>
              <Tooltip
                styles={{
                  body: { color: "#fff", backgroundColor: "#000" },
                }}
                title={<pre className="tooltip-product-card">Impressions</pre>}
              >
                <Row justify="center">
                  <Image
                    className="product-bill-image"
                    src={Metrics}
                    preview={false}
                    alt="Products"
                  ></Image>{" "}
                </Row>
                <Row justify="center">
                  <span className="product-type">
                    {Number(product?.secondImpression).toLocaleString()}{" "}
                    <span>+ per week</span>
                  </span>
                </Row>
              </Tooltip>
            </Col>
            <Divider type="vertical" className="product-card-divider-css" />

            <Col span={4}>
              <Tooltip
                styles={{
                  body: { color: "#fff", backgroundColor: "#000" },
                }}
                title={<pre className="tooltip-product-card">Product Type</pre>}
              >
                <Row justify="center">
                  <Image
                    className="product-bill-image"
                    src={Billboard}
                    preview={false}
                    alt="Products"
                  ></Image>{" "}
                </Row>
                <Row justify="center">
                  <span className="product-type">{product?.type}</span>
                </Row>
              </Tooltip>
            </Col>

            <Col span={4} className="product-last-section-detail">
              <div>
                <Space direction="vertical">
                  <div className="procduct-price-detail-section">
                    <div>
                      {!safeIncludes(
                        product?.rateCard,
                        "Estimated Market Value",
                      ) ? (
                        <div>
                          <Text strong className="price-text">
                            {formatToUSCurrency(
                              Number(product?.rateCard)?.toFixed(2),
                            )}
                          </Text>
                          {""}
                          <span className="per-week"> Per 4 Weeks</span>
                        </div>
                      ) : (
                        <>
                          {showAIPrice && product?.id === productId ? (
                            <>
                              {predictionLoader ? (
                                <div className="product-card-loader">
                                  <Spin size="small" />
                                </div>
                              ) : (
                                <Badge
                                  count={
                                    <span>
                                      <div>
                                        <span strong className="price-text">
                                          {formatToUSCurrency(
                                            getPredictedPrice(
                                              prices?.predicted_price
                                                ?.estimated_price,
                                            ),
                                          )}
                                        </span>
                                        <span className="per-week">
                                          {" "}
                                          Per 4 Weeks
                                        </span>
                                      </div>
                                      <div className="range-section">
                                        <Image
                                          className="sparkles"
                                          src={ChatBotSparkles}
                                          preview={false}
                                        />
                                        <span className="default-color">
                                          {" "}
                                          Estimated Market Value
                                        </span>{" "}
                                        <Tooltip
                                          placement="top"
                                          title={estimatedPriceTooltip()}
                                        >
                                          <InfoCircleOutlined />
                                        </Tooltip>
                                        <div className="price-range">
                                          Range:{" "}
                                          {formatToUSCurrency(
                                            getPredictedPrice(
                                              prices?.predicted_price
                                                ?.price_lower_limit,
                                            ),
                                          )}{" "}
                                          -{" "}
                                          {formatToUSCurrency(
                                            getPredictedPrice(
                                              prices?.predicted_price
                                                ?.price_upper_limit,
                                            ),
                                          )}
                                        </div>
                                      </div>
                                    </span>
                                  }
                                  color="#f5f5f5"
                                ></Badge>
                              )}
                            </>
                          ) : (
                            <Text
                              strong
                              className="ai-price"
                              onClick={(e) => {
                                e.stopPropagation();
                                showAIPrice(product?.id);
                              }}
                            >
                              {rateCard}
                            </Text>
                          )}
                        </>
                      )}
                    </div>

                    {new Date(Number(product?.to_date?.$date?.$numberLong)) <=
                      new Date() && (
                      <div
                        className="notify-section"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isLoggedIn) {
                            setLoginPopoverVisible(true);
                            return;
                          }
                          setSelectedProduct(product);
                          setNotify(true);
                        }}
                      >
                        {" "}
                        <Button
                          type="link"
                          key={product?.id}
                          className="notify-me"
                        >
                          <NotifyIcon style={{ color: "#d2042d" }} />
                          Notify me
                        </Button>{" "}
                      </div>
                    )}
                  </div>
                  {recommendFlag && (
                    <>
                      <div
                        className="why-recommended-section"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRecommendedProductTypeModal(product);
                        }}
                      >
                        <Button
                          type="link"
                          key={product?.id}
                          className="product-recomended-type"
                        >
                          Why this product is recommended?
                        </Button>{" "}
                      </div>
                      <div className="add-product-section">
                        <Button
                          type="link"
                          key={product?.id}
                          className="product-recomended-type"
                        >
                          {" "}
                          <AddIcon width={15} height={15} />
                          Add Product
                        </Button>{" "}
                      </div>
                    </>
                  )}
                </Space>
              </div>
            </Col>
          </Row>
        </Card>
      </Col>
    );
  };
  return (
    <>
      <Row gutter={[16, 16]} style={{ justifyContent: "center" }}>
        {recommendedProducts?.length > 0 ? (
          recommendedProducts?.map((product) => productView(product))
        ) : updatedProducts && updatedProducts?.length > 0 ? (
          <>
            <>
              {updatedProducts?.map((product, detailIndex) => (
                <React.Fragment key={product?.id}>
                  <div style={{ width: "100%" }}>
                    {productView(product, product?.rateCard)}
                  </div>
                  {detailIndex + 1 === 5 && (
                    <div
                      style={{
                        textAlign: "center",
                        width: "950px",
                      }}
                    >
                      <AdPlacement
                        type="products"
                        position="banner ad (6th tile"
                        index={1}
                      />
                    </div>
                  )}
                  {updatedProducts.length > 5 &&
                    detailIndex == updatedProducts.length - 1 && (
                      <div
                        style={{
                          width: "950px",
                          textAlign: "center",
                        }}
                      >
                        <AdPlacement
                          type="products"
                          position="bottom"
                          index={2}
                        />
                      </div>
                    )}
                  {updatedProducts.length < 5 &&
                    detailIndex == updatedProducts.length - 1 && (
                      <div
                        style={{
                          width: "950px",
                          textAlign: "center",
                        }}
                      >
                        <AdPlacement
                          type="products"
                          position="bottom"
                          index={2}
                        />
                      </div>
                    )}
                </React.Fragment>
              ))}
            </>
          </>
        ) : (
          <div>
            <EmptyViewCard
              header={"Matches..."}
              text={
                "There are no products available for your selected criteria. Please update your filters to explore more options."
              }
            />
          </div>
        )}
      </Row>
      <ProductModalPopUp
        key={isProductPopUp}
        contentName={"Check Product Availability"}
        isProductPopUp={isProductPopUp}
        productId={selectedProduct?.id}
        setSelectedProduct={setSelectedProduct}
        isCampaignsPage={isCampaignsPage}
      />
      <Modal
        open={notify}
        onCancel={() => setNotify(false)}
        closable={true}
        className="notify-modal"
        footer={false}
        centered
      >
        <NotifyModel
          openNotify={notify}
          setNotify={setNotify}
          product={selectedProduct}
        />
      </Modal>
      <RecommendedProductType
        recommendedProductTypeModal={recommendedProductTypeModal}
        setRecommendedProductTypeModal={setRecommendedProductTypeModal}
        recommendedProductType={recommendedProductType}
      />
      <LoginAlert
        loginPopoverVisible={loginPopoverVisible}
        setLoginPopoverVisible={setLoginPopoverVisible}
      />
    </>
  );
};
